import { IsDate, IsNotEmpty, IsOptional, IsString } from 'class-validator';

export class UserCredentialsDto {
  @IsOptional()
  @IsDate()
  lastUpdateAt?: Date;
}

export class UserAdminCredentialsDto extends UserCredentialsDto {
  @IsString()
  @IsNotEmpty()
  keycloakUuid!: string;
}
